import { normalizeKey } from '@deity-io/di-data-basics';
import { META_KEY } from 'contracts/constants';
import * as _ from 'lodash';
import type { ISchemaState } from './SchemaContext';

export class SchemaContextHelper {
  /* eslint-disable-next-line no-empty-function */
  constructor(readonly state: ISchemaState) {}

  getSelectedFieldInfo = (): {
    name: string;
    path: Array<string>;
    fieldJson: Record<string, any>;
    settings: Record<string, any>;
    isContainer: boolean;
    settingsPath: Array<string>;
  } | void => {
    if (this.state && this.state.schema && this.state.selectedField) {
      const path = [...this.state.selectedField];
      const field = path.length ? _.get(this.state.schema, path) : this.state.schema;
      let name: string;
      if (path.length) {
        name = path.pop() as string;
      } else if (META_KEY in field) {
        if ('name' in field[META_KEY]) {
          name = field[META_KEY].name as string;
        } else {
          name = normalizeKey(this.state.name);
        }
      } else if ('name' in field) {
        name = field.name as string;
      } else {
        name = normalizeKey(this.state.name);
      }

      if (field) {
        const isContainer = META_KEY in field;

        return {
          name,
          path: [...this.state.selectedField],
          fieldJson: field,
          isContainer,
          settings: isContainer ? field[META_KEY] : field,
          settingsPath: isContainer ? [...this.state.selectedField, META_KEY] : this.state.selectedField
        };
      }
    }
  };
}
